// SetupCompletenessPill — persistent header nudge that shows "You're 60%
// set up — [next step] left" until the account hits 100% completion.
// Dismissible for the session (clicking × hides for 24h via sessionStorage)
// but returns on every fresh load so the owner can't accidentally forget
// there's setup left. Click the pill → jumps back into the SetupWizard.

import React, { useEffect, useState } from 'react';
import { G, api } from '../theme.js';

export function SetupCompletenessPill({ onResume }) {
  const [progress, setProgress] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    try {
      const until = Number(sessionStorage.getItem('setupPillDismissedUntil') || 0);
      if (Date.now() < until) setDismissed(true);
    } catch {}
    api('/api/onboarding/progress').then(setProgress).catch(()=>{});
  }, []);

  if (!progress || progress.isComplete || dismissed) return null;

  const pct = progress.percent || 0;
  const next = progress.nextStep;

  return <div style={{
    display:'flex', alignItems:'center', gap:10,
    padding:'6px 10px 6px 6px', borderRadius:14,
    background:`linear-gradient(135deg,${G.purpleDim},${G.input})`,
    border:`1px solid ${G.purple}55`,
    cursor:'pointer', fontSize:12, fontWeight:600,
  }} onClick={onResume}>
    <div style={{
      position:'relative', width:34, height:34, borderRadius:17,
      background:`conic-gradient(${G.purple} ${pct*3.6}deg, ${G.input} 0)`,
      display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0,
    }}>
      <div style={{
        position:'absolute', inset:3, borderRadius:14, background:G.bg,
        display:'flex', alignItems:'center', justifyContent:'center',
        fontSize:10, fontWeight:800, color:G.purple,
      }}>{pct}%</div>
    </div>
    <div style={{ display:'flex', flexDirection:'column', minWidth:0 }}>
      <span style={{ color:G.text, whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>
        Setup {pct}% complete
      </span>
      {next && <span style={{ color:G.textMuted, fontSize:11, whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>
        Next: {next.label}
      </span>}
    </div>
    <button onClick={e => { e.stopPropagation();
      try { sessionStorage.setItem('setupPillDismissedUntil', String(Date.now() + 24*60*60*1000)); } catch {}
      setDismissed(true);
    }} style={{ background:'none', border:'none', color:G.textMuted, fontSize:16, cursor:'pointer', padding:'2px 6px' }}>×</button>
  </div>;
}
